import { createStyles, Theme, Typography, WithStyles, withStyles } from '@freighthub/silhouette-core'
import { Component } from 'react'
import { i18n, I18nInterface } from 'utils/localisation'

import { IActivityTitle } from '../messages/MessageSectionType'

const headerStyles = (theme: Theme) =>
  createStyles({
    header: {
      minWidth: '100px',
      width: '100px',
      margin: theme.spacing(0.5, 1, 1),
      display: 'flex',
      alignItems: 'center',
      textAlign: 'left',
    },
  })

interface IHeaderProps extends I18nInterface, WithStyles<typeof headerStyles, false> {
  title: IActivityTitle
}

@i18n
class THeader extends Component<IHeaderProps> {
  get titleText() {
    const { title, localisationStore } = this.props
    // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
    return title.translate ? localisationStore.translate(title.text).slice(0, 50) : title.text.slice(0, 50)
  }
  render() {
    const { classes } = this.props
    return (
      <Typography variant="body2" className={classes.header}>
        {this.titleText}
      </Typography>
    )
  }
}

export const Header = withStyles(headerStyles)(i18n(THeader))
